import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
// import moment from 'moment-timezone';
import '../../styles/components/DateTime.less'
// Force style-loader (inject as <style>) like the rc-collapse CSS elsewhere —
// a plain .css import goes through MiniCssExtractPlugin and isn't linked in the
// dev HTML, so the datepicker rendered unstyled once the CDN link was removed.
import '!style-loader!css-loader!react-datepicker/dist/react-datepicker.css';
import { withTranslation, WithTranslation } from "react-i18next";

interface DateTimeOwnProps {
  selected?: string | number | Date | null;
  parentCallback: (date: Date | null) => void;
}

const DateTime = (props: DateTimeOwnProps & WithTranslation) => {
  const { t } = props; // [t, i18n]

  const [startDate, setStartDate] = useState<Date | null>(() => {
    // react-datepicker v9 expects a valid Date (or null) and throws
    // "Invalid time value" on anything else — including the non-date
    // sentinels this picker can receive (e.g. '-infinity' / 'infinity').
    const parsed = props.selected ? new Date(props.selected) : null;
    return (parsed && !isNaN(parsed.getTime())) ? parsed : null;
  });

  const handleChange = (date: Date | null) => {
    setStartDate(date);
    props.parentCallback(date);
  };

  return (
    <div className="container">
      <form>
        <div className="form--group time-range-input">
          <DatePicker
            timeInputLabel={t('dashboard.editor.time.label')}
            timeFormat={t('dashboard.editor.time.timeFormat')}
            dateFormat={t('dashboard.editor.time.dateFormat')}
            showWeekNumbers
            showTimeSelect
            // react-datepicker v9 defaults to full weekday names; show 2-letter
            // abbreviations (Su, Mo, …) so the header fits the column width.
            formatWeekDay={(day) => day.substring(0, 2)}
            selected={startDate}
            onChange={handleChange}
          />
        </div>
      </form>
    </div>
  );
};

export default withTranslation('common')(DateTime);
